<template lang="pug">
.featured-index(v-element-visibility="onElementVisibility")
  Tabs.tabs-index(v-model="active" :tabs="tabNames" desktopScroll)
    template(#header)
      .index-logo
        StaticImage(src='UI/logos/theindex-logo_oi2cz1.svg' role="presentation" alt="The Index" :width="300" :height="62" ssr contain)
  Carousel(:arrowOffset="arrowOffset")
    .index-content
      IndexCard.loading(v-if='selectedCategory.posts?.length === 0' v-for='x in 4' :key="x")
      IndexCard(
        :post="post"
        v-for="post in selectedCategory.posts"
        :key="post.id"
        :show-category="false"
      )
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { vElementVisibility } from '@vueuse/components'
import type { ITheIndexPost } from '../pages/theindex/types'
import IndexCard from '@/js/pages/theindex/components/index-card.vue'
import { BASE_FIELDS, loadPosts } from '@/js/pages/theindex/helpers/search'
import { useRogue } from '@/js/services/Rogue'
import { useHttpStore } from '@/js/stores/httpStore'
import { THE_INDEX_CATEGORY_IDS } from '@/js/pages/theindex/constants'

const rogue = useRogue()
const httpStore = useHttpStore()

type Category = {
  name: string,
  id: string,
  posts: ITheIndexPost[],
  loading: boolean,
}

const categories: Category[] = [
  { name: 'Featured', id: '17', posts: [], loading: false },
  { name: 'Events', id: `${THE_INDEX_CATEGORY_IDS.EVENTS}`, posts: [], loading: false },
  { name: 'Athletes', id: `${THE_INDEX_CATEGORY_IDS.ATHLETES}`, posts: [], loading: false },
  { name: 'Gym Tours', id: '804', posts: [], loading: false },
  { name: 'Movement Library', id: '805', posts: [], loading: false },
  { name: 'Gear & How To', id: '806', posts: [], loading: false },
  { name: 'Documentary', id: `${THE_INDEX_CATEGORY_IDS.DOCUMENTARY}`, posts: [], loading: false },
  { name: 'History', id: '19', posts: [], loading: false },
  { name: 'News & Press', id: '105', posts: [], loading: false },
  { name: 'Lifestyle', id: '104', posts: [], loading: false },
]

defineProps({
  arrowOffset: {
    type    : String,
    default : '130px',
  },
})

const active = ref('Featured')
const tabNames = categories.map(c => c.name)
const selectedCategory = ref<Category>(categories.find(cat => cat.name === active.value)!)

async function load() {
  const selected = selectedCategory.value
  if (selected.posts.length === 0) {
    selected.loading = true
    try {
      const query = { categories: selected.id }
      selected.posts = await loadPosts(rogue, query, {
        perPage : 12,
        fields  : BASE_FIELDS.concat('excerpt'),
      })
      // Feeds post.vue's listing-cache scan so its skeleton works for this carousel.
      httpStore.setCache(`index-${JSON.stringify(query)}`, { posts: selected.posts })
    } catch (e) {
      // if the call fails still set loading to be false
      selected.loading = false
    }
  }
  selected.loading = false
}

function init() {
  selectedCategory.value = categories.find(cat => cat.name === active.value)!
  load()
}

function onElementVisibility(isVisible: boolean) {
  if (isVisible) {
    init()
  }
}

watch(active, (newVal) => {
  selectedCategory.value = categories.find(cat => cat.name === newVal)!
  load()
})
</script>
<style scoped lang="scss">
.index-logo{
  width: 200px;
  padding-bottom: 12px;
}

.index-results{
  width: 100%;
}

.tabs-index{
  white-space: nowrap;
}

.index-content {
  display:flex;
  flex-direction: row;

  .card {
    width:500px;
    min-height: 450px;
    margin-right: 16px;
  }
}

@include not-desktop() {
  .index-logo{
    width: 150px;
  }
}

@include mobile() {
  .index-content .card{
    width: 250px;
    min-height: 270px;
  }
}

</style>
